import {
  cachedGyymPrefetch,
  composeServerProps,
  withGyymAuth,
  withGyymSSR,
} from '@gyym/sdk-next'
import { GetServerSideProps } from 'next'
import React from 'react'

import { SingleColumnLayout } from '@/components/Layouts/legacy/SingleColumnLayout'
import { SearchView } from '@/components/Views/SearchView'
import { buildOgImageUrl } from '@/lib/ogiGenerator'

export const getServerSideProps: GetServerSideProps = composeServerProps(
  withGyymAuth(),
  withGyymSSR(async (_ctx, _client) => [
    // ユーザー非依存のカタログのため、サーバー内共有キャッシュから取得する
    cachedGyymPrefetch((c) => c.user.facilities.searchMetadata),
    cachedGyymPrefetch((c) => c.user.prefectures.list),
  ]),
)

const Search = () => {
  return (
    <SingleColumnLayout
      title="検索MENU | GYYM (都度利用サービス)"
      description="GYYM (都度利用サービス) の検索メニューです。利用料金は利用した分だけ！ジム初心者やしっかり体験したい方も安心の入会金無料・ビジターOKのフィットネスジム・スタジオを探せます。"
      keywords={[
        'gyym',
        'GYYM',
        'ジム',
        'フィットネス',
        'スタジオ',
        'ジム 都度利用',
        'ジム 体験',
        'ジム 入会金無料',
        'ジム 初心者',
      ]}
      ogImageUrl={buildOgImageUrl`検索MENU`}
      breadcrumbs={[
        {
          label: 'TOP',
          href: '/',
        },
        {
          label: '検索MENU',
          href: '/search',
        },
      ]}
    >
      <SearchView />
    </SingleColumnLayout>
  )
}

export default Search
